import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Button } from "react-migration/components/Button";

type OverdueInvoiceBannerProps = {
  onClose: () => void;
};

export const OverdueInvoiceBanner = ({ onClose }: OverdueInvoiceBannerProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <div
      id="overdue-invoice-banner"
      className="absolute bottom-0 left-0 w-full p-2 bg-400 z-9999 text-warning-800"
      data-testid="overdue-invoice-banner"
    >
      <div className="flex items-center text-center">
        <div className="flex-1">
          <strong>
            {t("nav.overdue_invoice_banner.your_invoice_is_overdue._pay_now_to_keep_your_landinsight_account_active")}{" "}
          </strong>
          {t("nav.overdue_invoice_banner.payments_take_up_to")}
        </div>
        <Button
          variant="ghost"
          className="cursor-pointer hover:text-background-surface-warning-accent"
          onClick={handleClose}
        >
          <i className="text-2xl icon-lt-close-line" />
        </Button>
      </div>
    </div>
  );
};

OverdueInvoiceBanner.displayName = "OverdueInvoiceBanner";
